import React, { useContext, useState, useRef, useEffect } from "react";
import styles from "./styles/NavBar.module.css";
import { NavLink, useLocation, useParams } from "react-router-dom";
import NavLogo from "../ui/nav_logo/NavLogo";
import DataContext from "../../context/DataContext";
import NavButton from "../ui/navbutton/NavButton";
import BurgerButton from "../ui/burger_button/BurgerButton";
import useClickOutside from "../../hooks/useClickOutside";

import InputLanguage from "../ui/input_language/InputLanguage";
import { useTranslation } from "react-i18next";
import UserWidget from "../ui/user_widget/UserWidget";
import AuthContext from "../../context/AuthContext";
import ShoppingCartNav from "../ui/shopping_cart_nav/ShoppingCartNav";
import POSDataContext from "../../context/POSDataContext";
import { ReactComponent as IconSearch } from "../../assets/search.svg";
import { ReactComponent as IconLogout } from "../../assets/logout.svg";
import i18n from "i18next";
/**
 * Navagation bar main component
 */
const NavBar = () => {
    const {
        currentCustom, // {Object} - The object that contains the client customisations
        // defaultLanguage, // {String} - The default language code
        languages, // {Array} - List of available languages
        homePath, // {String} - The home page path
        isServiceDataAvailable, // {Boolean} - Flag indicating if service data is available
        islocalizationsAvailable, // {Boolean} - Flag indicating if localizations are available
        isRedirecting, // {Boolean} - Flag indicating if redirection is in progress
        showPaymentForm,
    } = useContext(DataContext);
    const {
        count, // {Integer} - The count of items in the shopping cart
        userLogout, // {Function} - The function used to log out the user
    } = useContext(POSDataContext);
    const {
        user, // {Object} - The authenticated user object
    } = useContext(AuthContext);
    const [isOpenMenu, setIsOpenMenu] = useState(false);
    const burgerMenuRef = useRef();
    const { t, ready } = useTranslation();
    const location = useLocation();
    const [forceClose, setForceClose] = useState(false);
    const [redirectAdress, setRedirectAdress] = useState(homePath);
    const [isHeaderL1Available, setIsHeaderL1Available] = useState(false);
    const [isHeaderL2Available, setIsHeaderL2Available] = useState(false);

    useEffect(() => {
        setRedirectAdress(
            location.pathname.includes("/pos") && user
                ? `${homePath}/tickets`
                : homePath,
        );
    }, [location, user, homePath]);

    useEffect(() => {
        if (!ready) return;
        const l1HasMessage =
            t("logoLine1")?.trim() !== "" &&
            t("logoLine1")?.trim() !== "logoLine1";
        const l2HasMessage =
            t("logoLine2")?.trim() !== "" &&
            t("logoLine2")?.trim() !== "logoLine2";

        setIsHeaderL1Available(l1HasMessage);
        setIsHeaderL2Available(l2HasMessage);
    }, [ready, t]);

    /**
     * Toggle the mobile menu state
     * @param {event} event - The event object
     */
    const toggleMenu = (event) => {
        event.stopPropagation();
        setIsOpenMenu((prevIsOpenMenu) => !prevIsOpenMenu);
        setForceClose((prev) => !prev);
    };

    /**
     * Close the mobile menu
     */
    const closeMenu = () => {
        setIsOpenMenu(false);
    };

    // Detects clicks outside the mobile menu and invokes the closeMenu function
    useClickOutside(burgerMenuRef, closeMenu);

    return (
        !isRedirecting &&
        isServiceDataAvailable &&
        islocalizationsAvailable && (
            <header
                className={`${styles.main_header_container} ${
                    location.pathname.includes("/pos")
                        ? styles.main_heade_pos
                        : ""
                } ${
                    showPaymentForm ? styles.main_header_to_back : ""
                } flex-container`}
            >
                <section
                    className={`${styles.header_container} flex-container`}
                >
                    <nav
                        className={`${styles.main_nav_container}  main-container flex-container `}
                    >
                        <div
                            className={`${styles.main_logo_burger_container} ${
                                location.pathname.includes("/pos")
                                    ? styles.container_flip
                                    : ""
                            } flex-container `}
                        >
                            <div
                                className={`${styles.main_widget_container} ${!location.pathname.includes("/pos") ? styles.hide_widget : ""} `}
                            >
                                {user ? (
                                    <div
                                        className={`${styles.mobile_user_container}   ${
                                            location.pathname.includes("/pos")
                                                ? ""
                                                : styles.displayOverride
                                        } `}
                                        onClick={closeMenu}
                                    >
                                        <UserWidget
                                            forceClose={forceClose}
                                            links={[
                                                {
                                                    link: `${homePath}/cash-operations`,
                                                    body: t("cash operations"),
                                                },
                                                {
                                                    link: `${homePath}/summary, {"state":{"scrollTo":"closeSession"}}`,

                                                    body: t("close session"),
                                                },
                                                {
                                                    onClickFucntion: userLogout,
                                                    body: t("logout"),
                                                    icon: IconLogout,
                                                },
                                            ]}
                                            userName={user?.userName}
                                        />
                                    </div>
                                ) : (
                                    <></>
                                )}
                            </div>
                            <div className={`flex-container`}>
                                <div
                                    className={`${styles.nav_logo_container} flex-container`}
                                    draggable="false"
                                >
                                    <NavLink
                                        className={`${styles.header_logo}`}
                                        to={redirectAdress}
                                        // to={homePath}
                                        aria-label={`logo of ${currentCustom?.company}`}
                                        draggable={"false"}
                                    >
                                        <NavLogo height={60} />
                                    </NavLink>
                                    {isHeaderL1Available ||
                                    isHeaderL2Available ? (
                                        <div
                                            className={` ${styles.logo_lines_container} v-flex-container`}
                                        >
                                            {isHeaderL1Available ? (
                                                <h3
                                                    className={` ${styles.logo_line}`}
                                                >
                                                    {t("logoLine1")}
                                                </h3>
                                            ) : (
                                                <></>
                                            )}
                                            {isHeaderL2Available ? (
                                                <h3
                                                    className={` ${styles.logo_line}`}
                                                >
                                                    {t("logoLine2")}
                                                </h3>
                                            ) : (
                                                <></>
                                            )}
                                        </div>
                                    ) : (
                                        <></>
                                    )}
                                </div>
                            </div>
                            <div className={`${styles.main_burger_container}`}>
                                <BurgerButton
                                    isOpenMenu={isOpenMenu}
                                    toggleMenu={toggleMenu}
                                />
                            </div>
                        </div>

                        <ul
                            className={`${styles.nav_link_container} ${
                                isOpenMenu ? styles.nav_active : ""
                            } flex-container`}
                            ref={burgerMenuRef}
                        >
                            {/* the language selector */}
                            {languages && languages?.length > 1 ? (
                                <li
                                    className={`${styles.language_input_container}`}
                                >
                                    <InputLanguage
                                        selectedOption={i18n.language}
                                        options={languages}
                                    />
                                </li>
                            ) : (
                                <></>
                            )}
                            {/* only visible when not in the POS module or in the customization page */}
                            {!location.pathname.includes("customization") ? (
                                !location.pathname.includes("/pos") ? (
                                    <>
                                        <li
                                            className={`${styles.nav_link_item}`}
                                            onClick={closeMenu}
                                        >
                                            <NavButton
                                                body={
                                                    <>
                                                        <IconSearch
                                                            className={`${styles.nav_button_icon} icon-component`}
                                                        />
                                                        {t(`search`)}
                                                    </>
                                                }
                                                link={homePath}
                                                fullWidth={true}
                                                size={"adapt"}
                                            />
                                        </li>
                                        {/* the custo buttons from the client's customization */}
                                        {currentCustom?.nav
                                            ?.filter(
                                                (button) =>
                                                    button?.enable &&
                                                    t(button?.body) &&
                                                    t(button?.link),
                                            )
                                            .map((button) => (
                                                <li
                                                    className={`${styles.nav_link_item} `}
                                                    key={button?.id}
                                                    onClick={closeMenu}
                                                >
                                                    <NavButton
                                                        body={t(button?.body)}
                                                        link={button?.link}
                                                        size={"adapt"}
                                                        newWindow={true}
                                                        fullWidth={true}
                                                    />
                                                </li>
                                            ))}
                                    </>
                                ) : user ? (
                                    // the POS module buttons and widget
                                    <>
                                        <li
                                            className={`  ${styles.main_user_container} `}
                                            onClick={closeMenu}
                                        >
                                            <UserWidget
                                                forceClose={forceClose}
                                                links={[
                                                    {
                                                        link: `${homePath}/cash-operations`,
                                                        body: t(
                                                            "cash operations",
                                                        ),
                                                    },
                                                    {
                                                        link: `${homePath}/summary, {"state":{"scrollTo":"closeSession"}}`,

                                                        body: t(
                                                            "close session",
                                                        ),
                                                    },
                                                    {
                                                        onClickFucntion:
                                                            userLogout,
                                                        body: t("logout"),
                                                        icon: IconLogout,
                                                    },
                                                ]}
                                                userName={user?.userName}
                                            />
                                        </li>
                                        <li
                                            className={`  ${styles.main_cart_container}`}
                                            onClick={closeMenu}
                                        >
                                            <ShoppingCartNav
                                                count={count}
                                                link={`${homePath}/shopping-cart`}
                                            />
                                        </li>
                                        {/* show if there are ticket search group */}
                                        {currentCustom?.pos?.tickets &&
                                        currentCustom?.pos?.tickets.length ? (
                                            <li
                                                className={`${styles.nav_link_item} `}
                                                onClick={closeMenu}
                                            >
                                                <NavButton
                                                    body={t("tickets")}
                                                    link={`${homePath}/tickets`}
                                                    size={"adapt"}
                                                    fullWidth={true}
                                                />
                                            </li>
                                        ) : (
                                            <></>
                                        )}
                                        {/* show if there are permit search groups */}
                                        {currentCustom?.pos?.permits &&
                                        currentCustom?.pos?.permits.length ? (
                                            <li
                                                className={`${styles.nav_link_item} `}
                                                onClick={closeMenu}
                                            >
                                                <NavButton
                                                    body={t("permits")}
                                                    link={`${homePath}/permits`}
                                                    size={"adapt"}
                                                    fullWidth={true}
                                                />
                                            </li>
                                        ) : (
                                            <></>
                                        )}
                                        <li
                                            className={`${styles.nav_link_item} `}
                                            onClick={closeMenu}
                                        >
                                            <NavButton
                                                body={t("services")}
                                                link={`${homePath}/services`}
                                                size={"adapt"}
                                                fullWidth={true}
                                            />
                                        </li>
                                        <li
                                            className={`${styles.nav_link_item} `}
                                            onClick={closeMenu}
                                        >
                                            <NavButton
                                                body={t("summary")}
                                                link={`${homePath}/summary`}
                                                size={"adapt"}
                                                fullWidth={true}
                                            />
                                        </li>
                                    </>
                                ) : (
                                    <></>
                                )
                            ) : (
                                <></>
                            )}
                        </ul>
                    </nav>
                </section>
            </header>
        )
    );
};

export default NavBar;
